<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <!-- <b-form-group label-cols="3" label="Placeholder">
          <b-form-input @change="changeProp" v-model="field.params.placeholder"/>
        </b-form-group> -->
    <b-form-group label-cols="3" label="Tooltip">
      <b-form-input @change="changeProp" v-model="field.params.tooltip" />
    </b-form-group>

    <b-form-group label-cols="3" label="Layout">
      <b-form-select @change="changeProp" v-model="field.params.layout">
        <option value="checkbox">Check Box</option>
        <option value="switch">Switch</option>
        <option value="buttons">Yes/No Buttons</option>
        <option value="radios">Radio Buttons</option>
      </b-form-select>
    </b-form-group>

    <b-form-group label="Yes Score" label-cols="3" v-if="field.has_score">
      <b-form-input
        @change="changeProp"
        type="number"
        v-model="field.params.yesScore"
      />
    </b-form-group>
    <b-form-group label="No Score" label-cols="3" v-if="field.has_score">
      <b-form-input
        @change="changeProp"
        type="number"
        v-model="field.params.noScore"
      />
    </b-form-group>
    <b-form-group
      label="N/A Score"
      label-cols="3"
      v-if="field.has_score && field.params.allow_na"
    >
      <b-form-input
        @change="changeProp"
        type="number"
        v-model="field.params.naScore"
      />
    </b-form-group>

    <span
      v-if="
        field.params.layout === 'buttons' || field.params.layout === 'radios'
      "
    >
      <b-form-group label-cols="3" label="Yes Label">
        <b-form-input @change="changeProp" v-model="field.params.yesLabel" />
      </b-form-group>
      <b-form-group label-cols="3" label="Yes Color">
        <b-form-select
          @change="changeProp"
          v-model="field.params.yesColor"
          :options="colorOptions"
        ></b-form-select>
      </b-form-group>
      <b-form-group label-cols="3" label="No Label">
        <b-form-input @change="changeProp" v-model="field.params.noLabel" />
      </b-form-group>
      <b-form-group label-cols="3" label="No Color">
        <b-form-select
          @change="changeProp"
          v-model="field.params.noColor"
          :options="colorOptions"
        ></b-form-select>
      </b-form-group>

      <b-form-group label-cols="3" label="">
        <b-form-checkbox @input="changeProp" v-model="field.params.allow_na"
          >Allow N/A</b-form-checkbox
        >
      </b-form-group>
      <b-form-group
        label-cols="3"
        label="N/A Label"
        v-if="field.params.allow_na"
      >
        <b-form-input @change="changeProp" v-model="field.params.naLabel" />
      </b-form-group>
      <b-form-group
        label-cols="3"
        label="N/A Color"
        v-if="field.params.allow_na"
      >
        <b-form-select
          @change="changeProp"
          v-model="field.params.naColor"
          :options="colorOptions"
        ></b-form-select>
      </b-form-group>
    </span>

    <!-- Default Settings -->
    <b-form-group label-cols="3" label="">
      <b-form-checkbox @input="changeProp" v-model="field.default_option"
        >Has Default</b-form-checkbox
      >
    </b-form-group>

    <b-form-group
      label-cols="3"
      label="Default Value"
      v-if="field.default_option"
    >
      <!-- Sets default value for Yes/No Buttons -->
      <div>
        <b-button :variant="yesColor" :value="true" @click="setDefault(true)">
          <checkbox-outline-icon v-if="getDefaultValue == true" />
          {{ yesLabel }}
        </b-button>

        <b-button :variant="noColor" :value="false" @click="setDefault(false)">
          <checkbox-outline-icon v-if="getDefaultValue == false" />
          {{ noLabel }}
        </b-button>

        <b-button
          :variant="naColor"
          value="na"
          @click="setDefault('na')"
          v-if="field.params.allow_na"
        >
          <checkbox-outline-icon v-if="getDefaultValue == 'na'" />
          {{ naLabel }}
        </b-button>
      </div>
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import CheckboxOutlineIcon from "vue-material-design-icons/CheckBoxOutline.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";

export default {
  name: "YesNoNotesFilesProps",
  components: { WidgetCommonProps, CheckboxOutlineIcon },
  mixins: [WidgetPropMixin],
  computed: {
    getDefaultValue() {
      if (this.field.default_value) {
        return this.field.default_value.val;
      }
    },
    layout() {
      return this.field.params.layout || "checkbox";
    },
    yesLabel: function () {
      return this.field.params.yesLabel || "Yes";
    },
    yesColor: function () {
      if (this.getDefaultValue === true) return "success";

      return "";
    },
    noLabel: function () {
      return this.field.params.noLabel || "No";
    },
    noColor: function () {
      if (this.getDefaultValue === false) return "danger";

      return "";
    },
    naLabel: function () {
      return this.field.params.naLabel || "N/A";
    },
    naColor: function () {
      if (this.getDefaultValue === "na") return "warning";

      return "";
    },
    colorOptions() {
      return [
        { value: "primary", text: "Primary" },
        { value: "success", text: "Success" },
        { value: "danger", text: "Danger" },
        { value: "warning", text: "Warning" },
        { value: "info", text: "Info" },
        { value: "light", text: "Light" },
        { value: "dark", text: "Dark" },
      ];
    },
  },
  methods: {
    setDefault(value) {
      var objectValue = { val: value, comment: "", files: [] };
      this.$set(this.field, "default_value", objectValue);
    },
  },
};
</script>
